export default __webpack_public_path__ + "static/media/Smart Delivery and Apps.2f31edfe.png";